export default __webpack_public_path__ + "static/media/commonocean-search.7c37dd3a.md";